import { render, staticRenderFns } from "./ChooseFile.vue?vue&type=template&id=70a5aaea&scoped=true&"
import script from "./ChooseFile.vue?vue&type=script&lang=js&"
export * from "./ChooseFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a5aaea",
  null
  
)

export default component.exports